import { css } from 'styled-components';

/**
 * Positions the close icon on notification components.
 *
 * @example
 * import { notificationCloseMixin } from '@zillow/zrs-comet';
 *
 * const Component = styled.notification`
 *     ${notificationCloseMixin}
 * `;
 *
 * <Component>My notification</Component>
 *
 * @method
 * @return {CSSObject}
 */
export default () => css`
  cursor: pointer;
  position: absolute;
  right: 16px;
  top: 16px;

  .Icon.close {
    color: #fff;
  }
`;
